/**
 * Утилиты для работы с localStorage
 */

// Ключи localStorage, которые нужно сохранить при обновлении версии
export const PRESERVE_KEYS = [
    'user-token',           // Токен авторизации
    'user',                 // Данные пользователя
    'userRoles',            // Роли пользователя
    'agentCompany',         // Агентская компания
    'LOCAL_STORAGE_VERSION' // Текущая версия
];

/**
 * Умная очистка localStorage с сохранением важных данных
 * @param {string} reason - Причина очистки (для логирования)
 */
export function smartLocalStorageClear(reason = 'обновление версии') {
    // Сохраняем важные данные
    const preservedData = {};
    PRESERVE_KEYS.forEach(key => {
        if (localStorage.getItem(key) !== null) {
            preservedData[key] = localStorage.getItem(key);
        }
    });
    
    // Очищаем весь localStorage
    localStorage.clear();
    
    // Восстанавливаем важные данные
    Object.keys(preservedData).forEach(key => {
        if (key !== 'LOCAL_STORAGE_VERSION') { // Не восстанавливаем старую версию
            localStorage.setItem(key, preservedData[key]);
        }
    });
    
    console.log(`localStorage очищен с сохранением данных авторизации (${reason})`);
    
    return {
        preserved: Object.keys(preservedData).length,
        cleared: true
    };
}

/**
 * Получить список всех ключей в localStorage
 * @returns {Array} Массив ключей
 */
export function getAllLocalStorageKeys() {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
        keys.push(localStorage.key(i));
    }
    return keys;
}

/**
 * Получить размер localStorage в байтах
 * @returns {number} Размер в байтах
 */
export function getLocalStorageSize() {
    let total = 0;
    for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
            total += localStorage[key].length + key.length;
        }
    }
    return total;
}

/**
 * Проверить, есть ли данные авторизации в localStorage
 * @returns {boolean} true если пользователь авторизован
 */
export function hasAuthData() {
    return !!(localStorage.getItem('user-token') && localStorage.getItem('user'));
}

/**
 * Очистить только данные авторизации
 */
export function clearAuthData() {
    const authKeys = ['user-token', 'user', 'userRoles', 'agentCompany'];
    authKeys.forEach(key => {
        localStorage.removeItem(key);
    });
    console.log('Данные авторизации очищены');
}
